import { SxProps, Typography } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

export interface Props {
	text: string;
  underlined?: boolean;
}

const HighlightedText: React.FC<Props> = ({ text, underlined }) => {

  const sxStyle: SxProps = {
    fontFamily: "UnimedSans-Bold",
    fontSize: "16px",
    lineHeight: "30px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#156D44",
    textDecoration: underlined ? 'underline' : 'none'
  }

	const accessibility = useAccessibility();

  return (
    <Typography
      sx={sxStyle} 
      style={accessibility.textStyleAccessibility}
      >{text}</Typography>
  )
}

export default HighlightedText;